import React, { useState } from "react";
import { FiEdit, FiTrash } from "react-icons/fi";
import EditGalleryPlanModal from "./EditGalleryPlanModal/EditGalleryPlanModal";
import DeleteGalleryPlanModal from "./DeleteGalleryPlanModal/DeleteGalleryPlanModal";
import "./GalleryPlansTable.css";


const GalleryPlansTable = ({ data = [], page, limit, refreshData, activeTab, subTab }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const handleEdit = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    const handleDelete = (plan) => {
        setSelectedPlan(plan);
        setShowDeleteModal(true);
    };

    const renderHeaders = () => {
        if (activeTab === "gallery") {
            return (
                <>
                    <th className="td-sr">Sr.</th>
                    <th>Gallery Plan Days</th>
                    <th>Gallery Plan Charges</th>
                    <th>Action</th>
                </>
            );
        } else if (activeTab === "hourly") {
            return (
                <>
                    <th className="td-sr">Sr.</th>
                    <th>Role</th>
                    <th>Pricing Type</th>
                    <th>Price/Options</th>
                    <th>Action</th>
                </>
            );
        } else if (activeTab === "editing") {
            return (
                <>
                    <th className="td-sr">Sr.</th>
                    <th>Videos</th>
                    <th>Price</th>
                    <th>Subtitle</th>
                    <th>Action</th>
                </>
            );
        }
    };

    const renderRow = (item, index) => {
        const srNo = (page - 1) * limit + index + 1;
        if (activeTab === "gallery") {
            return (
                <tr key={item._id}>
                    <td className="td-sr">{srNo}</td>
                    <td>{item.days || "-"}</td>
                    <td>₹{item.charges || "-"}</td>
                    <td className="action-col">
                        <button className="chat-btn edit-btn" onClick={() => handleEdit(item)}>
                            <FiEdit size={16} />
                        </button>
                        <button className="chat-btn delete-btn" onClick={() => handleDelete(item)}>
                            <FiTrash size={16} />
                        </button>
                    </td>
                </tr>
            );
        } else if (activeTab === "hourly") {
            return (
                <tr key={item._id}>
                    <td className="td-sr">{srNo}</td>
                    <td>{item.role || "-"}</td>
                    <td>{item.pricingType === "fixed" ? "Fixed" : "Duration Based"}</td>
                    <td>
                        {item.pricingType === "fixed" 
                            ? `₹${item.fixedPrice}` 
                            : item.pricingOptions?.map(opt => `${opt.durationText}: ₹${opt.price}`).join(", ") || "-"}
                    </td>
                    <td className="action-col">
                        <button className="chat-btn edit-btn" onClick={() => handleEdit(item)}>
                            <FiEdit size={16} />
                        </button>
                        <button className="chat-btn delete-btn" onClick={() => handleDelete(item)}>
                            <FiTrash size={16} />
                        </button>
                    </td>
                </tr>
            );
        } else if (activeTab === "editing") {
            return (
                <tr key={item._id}>
                    <td className="td-sr">{srNo}</td>
                    <td>{item.numberOfVideos || item.videos || "-"}</td>
                    <td>₹{item.price || item.charges || "-"}</td>
                    <td>{item.subtitle || item.subTitle || "-"}</td>
                    <td className="action-col">
                        <button className="chat-btn edit-btn" onClick={() => handleEdit(item)}>
                            <FiEdit size={16} />
                        </button>
                        <button className="chat-btn delete-btn" onClick={() => handleDelete(item)}>
                            <FiTrash size={16} />
                        </button>
                    </td>
                </tr>
            );
        }
    };

    return (
        <div className="role-table-wrapper">
            <table className="role-table">
                <thead>
                    <tr>
                        {renderHeaders()}
                    </tr>
                </thead>

                <tbody>
                    {data.length > 0 ? (
                        data.map((item, index) => renderRow(item, index))
                    ) : (
                        <tr>
                            <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
                                No plans available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            
            <EditGalleryPlanModal
                show={showModal}
                plan={selectedPlan}
                onClose={() => setShowModal(false)}
                refreshData={refreshData}
                activeTab={activeTab}
                subTab={subTab}
            />

            <DeleteGalleryPlanModal
                show={showDeleteModal}
                plan={selectedPlan}
                onClose={() => setShowDeleteModal(false)}
                refreshData={refreshData}
                activeTab={activeTab}
            />
        </div>
    );
};

export default GalleryPlansTable;



